/**
 * Centered layout for login and password-reset grids.
 */
export function getLoginFormGridSx(theme) {
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    m: '0 auto',
    width: '95%',
    [theme.breakpoints.down(480)]: {
      top: '100px',
      transform: 'translate(-50%, 0)',
    },
  };
}
